import * as React from 'react';
import { Container, Box, Typography } from '@mui/material';
import Footer from './Footer';
import { useScrollToTop } from '../../hooks/useScrollToTop';

function InformationalLayout({
    title,
    subtitle,
    children,
    maxWidth = "lg",
    showOverlay = true
}) {
    useScrollToTop();

    return (
        <Box sx={{
            minHeight: '100vh',
            backgroundImage: 'url(/landing/hero.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            {/* Overlay */}
            {showOverlay && (
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    zIndex: 1
                }} />
            )}

            <Container maxWidth={maxWidth} sx={{ position: 'relative', zIndex: 2, pt: 4, pb: 8 }}>
                {/* Header */}
                <Box sx={{ mb: 6, textAlign: 'center' }}>
                    <Typography variant="h2" component="h1" sx={{
                        color: 'white',
                        fontWeight: 700,
                        mb: 2
                    }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="h6" sx={{
                            color: 'rgba(255,255,255,0.8)',
                            maxWidth: 600,
                            mx: 'auto'
                        }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>

                {/* Content */}
                {children}

            </Container>
            <Footer />
        </Box>
    );
}

export default InformationalLayout;
